import { createColumnHelper } from '@tanstack/react-table';

import { ColumnTypesInternal, WebEDIRowData } from 'support/types/webediTable';

import { DeleteCell } from '../../cells/WebEDI/CreateEdit/DeleteCell';

export const deletionPartial = (
  quantityField: string | undefined,
  columnHelper: ReturnType<typeof createColumnHelper<WebEDIRowData>>,
) =>
  columnHelper.display({
    id: ColumnTypesInternal.procuros_delete,
    meta: {
      type: ColumnTypesInternal.procuros_delete,
      optionalConfig: {
        quantityField,
      },
    },
    cell: DeleteCell,
  });
